import { ApiError } from '../services/api';

export function apiErrorMessage(
  error: unknown,
  fallback = 'Speichern fehlgeschlagen. Bitte erneut versuchen.'
) {
  if (error instanceof ApiError) {
    const data = error.data as {
      message?: string;
      error?: { issues?: Array<{ message: string; path?: (string | number)[] }> };
      errors?: Array<{ field: string; message: string }>;
    } | null;
    const issues = data?.error?.issues;
    if (issues?.length) return issues.map((issue) => issue.message).join(' · ');
    if (data?.errors?.length) return data.errors.map((issue) => issue.message).join(' · ');
    if (error.status === 409 && /modified|version|concurrent/i.test(data?.message ?? ''))
      return 'Dieser Stand wurde inzwischen geändert. Deine Eingaben bleiben erhalten. Gleiche sie vor erneutem Speichern mit dem aktuellen Stand ab.';
    if (error.status === 409)
      return (
        data?.message ??
        'Dieser Vorgang wurde inzwischen geändert. Deine Eingaben bleiben erhalten. Lade den aktuellen Stand zum Abgleich neu.'
      );
    if (error.status === 403) return 'Du hast für diese Aktion keine Berechtigung.';
    return data?.message ?? fallback;
  }
  return error instanceof Error && error.message ? error.message : fallback;
}
